var _defs, _circle, _path, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15.75,
    cy: 21.55,
    r: 1.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M6.36 12.3h3.41l4.6 4.97"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 15.75,
    cy: 33.13,
    r: 3.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 27.89,
    cy: 33.13,
    r: 3.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.22 17.27h23.59v4.47c0 2.61-2.12 4.73-4.73 4.73H14.96c-2.61 0-4.73-2.12-4.73-4.73v-4.47zM21.31 17.27h12.5c0-6.02-4.88-10.9-10.9-10.9h-1.6v6.53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParental);
export default __webpack_public_path__ + "static/media/Parental.bbf758d5f7ba9a4a0ec5e78bf3f60eba.svg";
export { ForwardRef as ReactComponent };